import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IWidget } from '../../interfaces/IWidget';
import { IWidgetSelection } from '../../interfaces/IWidgetSelection';
import { InteractivityWidgetSelectionService } from '../../services/interactivity-widget-selection.service';
import { InteractivityWidgetService } from '../../services/interactivity-widget.service';

@Component({
	selector: 'ie-align-distribute',
	templateUrl: './ie-align-distribute.component.html',
	styleUrls: ['./ie-align-distribute.component.scss']
})

export class IeAlignDistributeComponent implements OnInit, OnDestroy {
	@Output() onOpened: EventEmitter<any> = new EventEmitter<any>();
	@Output() closed: EventEmitter<any> = new EventEmitter<any>();

	options: any[] = [];
	selectedWidgets: IWidget[];

	private subscriptions = new Subscription();

	constructor(
		private widgetService: InteractivityWidgetService,
		private widgetSelectionService: InteractivityWidgetSelectionService) {
	}

	updateDisabled() {
		this.options.forEach((option) => {
			if (option.value.indexOf('dist') !== -1) {
				option.disabled = !this.selectedWidgets || this.selectedWidgets.length < 3;
			} else if (option.value.indexOf('align') !== -1) {
				option.disabled = !this.selectedWidgets || this.selectedWidgets.length < 2;
			}
		});
	}

	ngOnInit() {
		this.subscriptions.add(this.widgetSelectionService.widgetSelectionSubject.subscribe((data: IWidgetSelection) => {
			this.selectedWidgets = data.widgets;
			this.updateDisabled();
		}));
		this.options = [{
			value: 'dist-h',
			entity: 'dist-h',
			disabled: this.selectedWidgets.length < 3,
			htmlLabel: `distribute <strong>horizontally</strong>`,
			svgIcon: '/resources/img/interactivity/dist-h.svg',
		},
		{
			value: 'dist-v',
			entity: 'dist-v',
			disabled: this.selectedWidgets.length < 3,
			htmlLabel: `distribute <strong>vertically</strong>`,
			svgIcon: '/resources/img/interactivity/dist-v.svg',
		},
		{
			value: 'align-h-left',
			entity: 'align-h-left',
			disabled: this.selectedWidgets.length < 2,
			htmlLabel: `align <strong>left</strong>`,
			svgIcon: '/resources/img/interactivity/align-h-left.svg',
		},
		{
			value: 'align-h-center',
			entity: 'align-h-center',
			disabled: this.selectedWidgets.length < 2,
			htmlLabel: `align <strong>center</strong>`,
			svgIcon: '/resources/img/interactivity/align-h-center.svg',
		},
		{
			value: 'align-h-right',
			entity: 'align-h-right',
			disabled: this.selectedWidgets.length < 2,
			htmlLabel: `align <strong>right</strong>`,
			svgIcon: '/resources/img/interactivity/align-h-right.svg',
		},
		{
			value: 'align-v-top',
			entity: 'align-v-top',
			disabled: this.selectedWidgets.length < 2,
			htmlLabel: `align <strong>top</strong>`,
			svgIcon: '/resources/img/interactivity/align-v-top.svg',
		},
		{
			value: 'align-v-middle',
			entity: 'align-v-middle',
			disabled: this.selectedWidgets.length < 2,
			htmlLabel: `align <strong>middle</strong>`,
			svgIcon: '/resources/img/interactivity/align-v-middle.svg',
		},
		{
			value: 'align-v-bottom',
			entity: 'align-v-bottom',
			disabled: this.selectedWidgets.length < 2,
			htmlLabel: `align <strong>bottom</strong>`,
			svgIcon: '/resources/img/interactivity/align-v-bottom.svg',
		}];
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	onOptionSelected(option: any) {
		switch (option.value) {
			case 'dist-h':
				this.widgetService.distribute('h');
				break;
			case 'dist-v':
				this.widgetService.distribute('v');
				break;
			case 'align-v-top':
			case 'align-v-middle':
			case 'align-v-bottom':
				this.widgetService.align(option.value.split('align-v-')[1]);
				break;
			case 'align-h-left':
			case 'align-h-center':
			case 'align-h-right':
				this.widgetService.align(option.value.split('align-h-')[1]);
				break;
		}
	}
}
